import WalletModule from './views/Module.vue';
import WalletDeposit from './views/WalletDeposit.vue';
import WalletWithdraw from './views/WalletWithdraw.vue';
import DepositPaymentMethod from './views/DepositPaymentMethod.vue';


const WalletRoutes = {
    path: '/',
    component: WalletModule,
    children: [
      {
        path: 'wallet-deposit',
        name: 'wallet-deposit',
        component: WalletDeposit,
      },
      {
        path: 'wallet-withdraw',
        name: 'wallet-withdraw',
        component: WalletWithdraw,
      },
      {
        path: 'deposit-payment-method',
        name: 'deposit-payment-method',
        component: DepositPaymentMethod,
      },
    ],
}

export default WalletRoutes;